import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import Paging from "../../components/includes/Paging";
import { ChangeDateStringOnlyDate,unescapeHtml,isNull } from "../../components/common/Common";

import fixIcon from "../../img/icon/icon-fix.png";
import fileIcon from "../../img/icon/icon-file.svg";

//공지사항
const Notice = () => {
  //const mem_idx = Number(localStorage.getItem('mem_idx'));
  const navigate = useNavigate();
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  const [varTopList,setTopList] = useState([]);
  const [varNoticeList,setNoticeList] = useState([]);

  //페이지 조절 변수
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);
  
  //공지사항
  const GetNoticeList = async() => {
    const sendData = {boardMode:1,pageNum:varPageNum,pageSize:varPageSize};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/parent_get_board_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setTotalCount(datas.tcounts);

        //상단표시부
        const topList = datas.toplists;
        setTopList(topList);
        
        //하단표시부
        const noticeList = datas.results;
        const notmalList = noticeList.filter(el=>el.board_top===0);
        setNoticeList(notmalList);
        //if(varPageNum === 1) setNoticeList(notmalList);
        //else setNoticeList(varNoticeList.concat(notmalList));
      } else {
        alert(datas.message);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    GetNoticeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //console.log('pageNum',varPageNum);
    const showNum = (varPageNum-1)*varPageSize;
    if(varTotalCount > showNum) GetNoticeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum]);  

  const onAppInformationHandler = (e,board_idx) => {
    navigate(`/Parents/NoticeView/${board_idx}`)
  }

  return (
    <div className="vh-content normal-wrap">
      <HeaderUserTitle varPageTitle={'공지사항'} varBackString={'/Parents/MyPage'}/>
      <div className="vh-content-body">
        <div className="center-wrap">
          <div className="notice-wrap">
            {/* <Link to={'/Parents/MamaMonteInfo'}><img src={fixIcon} alt=""/> 마마몽떼 앱 출시 안내</Link> */}
            {varTopList.length === 0?null:
              <div className="top-fix">
                {varTopList.map((tops,i)=> (
                  <div key={'tops_'+i} onClick={e=>onAppInformationHandler(e,tops.board_idx)}>
                    <img src={fixIcon} alt=""/>{unescapeHtml(tops.board_title)}
                  </div>
                ))}
              </div>	
            }		
            {varNoticeList.length===0?null:
              <div className="notice-con">					
                <ul>
                  {varNoticeList.map((notice,i)=>(
                    <li key={'notice_'+i}>
                      <Link to={`/Parents/NoticeView/${notice.board_idx}`}>
                        <p>{unescapeHtml(notice.board_title)}&nbsp;{isNull(notice.board_file)?null:<img src={fileIcon} alt=""/>}</p>
                        <span className="date">{ChangeDateStringOnlyDate(notice.board_rdate)}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
                <Paging varTotalCount={varTotalCount} varPageSize={varPageSize} varPageNum={varPageNum} setPageNum={setPageNum} />
              </div>
            }
          </div>
				</div>
      </div>
    </div>
  )
}
export default Notice;